import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';

export default function LatestSection() {
  const latest = [...mangaList]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              刚刚更新的漫画作品，精彩不容错过
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 no-underline"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5 md:gap-6">
          {latest.map(manga => (
            <Link
              key={manga.id}
              to={`/manga/${manga.slug}`}
              className="group no-underline"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[3/4] bg-background-100">
                <img
                  src={manga.coverImage}
                  alt={`${manga.title} - 韩漫在线漫画`}
                  title={`${manga.title} - 下拉式阅读韩漫`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2">
                  <span className={`px-2 py-0.5 text-xs font-medium rounded-md text-white ${
                    manga.status === '连载中' ? 'bg-accent-500' : 'bg-secondary-500'
                  }`}>
                    {manga.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <div className="flex items-center gap-1 text-white/80 text-xs">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-time-line text-[10px]"></i>
                    </span>
                    更新至第{manga.chapters.length}话
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {manga.category} · {manga.updatedAt}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}